import React, { useState } from 'react';
import { MathJaxContext } from 'better-react-mathjax';
import { renderBlocks } from '../components/renderBlocks'; // ✅ Shared rendering

const TabsQA = ({ items }) => {
  const [activeTab, setActiveTab] = useState(0);

  if (!items || items.length === 0) {
    return <div className="text-center text-gray-500 mt-10">No learning content available.</div>;
  }

  return (
    <MathJaxContext>
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="flex flex-wrap border-b border-gray-300 mb-4">
          {items.map((item, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`px-4 py-2 font-medium text-sm border-b-2 transition-all duration-300 ${
                activeTab === index
                  ? 'border-indigo-600 text-indigo-700'
                  : 'border-transparent text-gray-500 hover:text-indigo-500'
              }`}
            >
              Q{item.order_index}
            </button>
          ))}
        </div>

        <div className="bg-white border rounded shadow p-6">
          <h3 className="text-indigo-700 font-semibold mb-2">
            Q{items[activeTab].order_index}
          </h3>

          <div className="text-gray-800 text-sm mb-4">
            {items[activeTab].question_blocks
              ? renderBlocks(items[activeTab].question_blocks)
              : renderBlocks([{ type: 'text', value: items[activeTab].question }])
            }
          </div>

          <div className="text-sm text-gray-700">
            <p className="font-semibold text-indigo-600 mb-1">Answer:</p>
            {items[activeTab].answer_blocks
              ? renderBlocks(items[activeTab].answer_blocks)
              : renderBlocks([{ type: 'text', value: items[activeTab].answer }])
            }
          </div>

          {items[activeTab].hint && (
            <div className="mt-2 text-sm text-gray-500">
              <strong>Hint:</strong> {items[activeTab].hint}
            </div>
          )}
        </div>
      </div>
    </MathJaxContext>
  );
};

export default TabsQA;
